import phone from 'phone';
import moment from 'moment';
import validator from 'validator';

const months = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'aout',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

export const isEmail = email => {
  if (email === undefined || email === null || typeof email !== 'string') {
    return false;
  }
  return validator.isEmail(email);
};

export const isDomain = domain => {
  const rule = /^[^\s.]{1,64}\.[^\s.]{1,64}$/;
  return domain.match(rule);
};

export const isContractReference = (value) => /^[a-zA-Z0-9]+$/.test(String(value || '').trim());

export const isPhone = str => {
  return phone(str, null, true).length === 2;
};

export const getDateString = str => {
  if (str === '') {
    return '';
  }
  const date = new Date(str);
  const ddd = date.getUTCDate();
  return `${ddd} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
};

export const get10LastLetters = str => String(str).slice(-10);

export const includes = (str1, str2) =>
  String(str1).toLowerCase().includes(String(str2).toLowerCase());

export const getListFromTreeString = str => {
  const treeData = JSON.parse(str);
  const result = [];
  while (true) {
    const first = treeData[0];
    treeData.shift();
    result.push(first.title);
    if (first.children) {
      for (let index = first.children.length - 1; index >= 0; index -= 1) {
        treeData.unshift(first.children[index]);
      }
    }
    if (treeData.length === 0) {
      break;
    }
  }

  return result;
};

export const includesCapitalLetter = str => {
  return /[A-Z]/.test(str);
};

export const includesNumber = str => {
  return /\d/.test(str);
};

export const getPasswordSecureWarning = password => {
  if (!password || password.length < 10) {
    return 'Password must be at least 10 characters';
  }
  const matchedCase = new Array();
  matchedCase.push('[!@#$%^&*;]'); // Special Charector
  matchedCase.push('[A-Z]'); // Uppercase Alpabates
  matchedCase.push('[0-9]'); // Numbers
  matchedCase.push('[a-z]'); // Lowercase Alphabates

  const messages = [
    'Password must include at least one special character (! , @, #, ...)',
    'Password must include at least one uppercase letter',
    'Password must include at least one number',
    'Password must include at least one lowercase letter'
  ];

  for (let i = 0; i < matchedCase.length; i++) {
    if (!new RegExp(matchedCase[i]).test(password)) {
      return messages[i];
    }
  }
  return null;
};
